import { ChangeEvent, FC, ReactNode, useState } from 'react';

import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  OutlinedInputProps,
} from '@mui/material';

type WaveUIInputPasswordProps = OutlinedInputProps & {
  name: string;
  label: ReactNode;
  value?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
  helperText?: string;
  error?: boolean;
};

const WaveUIInputPassword: FC<WaveUIInputPasswordProps> = ({
  name,
  label,
  value,
  onChange,
  placeholder,
  helperText,
  error,
  fullWidth = true,
  ...props
}) => {
  const [isPasswordVisible, setPasswordVisible] = useState(false);

  return (
    <FormControl
      variant='outlined'
      required={props.required}
      error={error}
      fullWidth={fullWidth}
    >
      <InputLabel htmlFor={`id_${name}`}>{label}</InputLabel>
      <OutlinedInput
        {...props}
        id={`id_${name}`}
        type={isPasswordVisible ? 'text' : 'password'}
        name={name}
        label={label}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        autoComplete='off'
        endAdornment={
          <InputAdornment position='end'>
            <IconButton
              onClick={() => setPasswordVisible(!isPasswordVisible)}
              edge='end'
            >
              {isPasswordVisible ? (
                <VisibilityOffIcon
                  sx={{ width: 24, height: 24, color: 'text.secondary' }}
                />
              ) : (
                <VisibilityIcon
                  sx={{ width: 24, height: 24, color: 'text.secondary' }}
                />
              )}
            </IconButton>
          </InputAdornment>
        }
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default WaveUIInputPassword;
